<modal-layout [modalTitle]="'Delivery address' | translate">
    <div modalBody>
        <p class="p2 m-t-2 m-t-7-s m-t-7-m">{{'Please enter a postcode to check delivery eligibility' | translate}}</p>
        <div class="flex m-t"
             style="gap: 16px;">
            <form-mui-field class="block pos-relative w-6"
                            [label]="('Postcode'| translate)"
                            [hideSideIcon]="true">
                <input type="text"
                       name="address"
                       [attr.placeholder]="'Postcode' | translate"
                       (keyup.enter)="confirm()"
                       [(ngModel)]="postcode"
                       required
                       autocomplete="postal-code"
                       (ngModelChange)="detectChanges()" />
            </form-mui-field>
            <button [status]="status"
                    [buttonStyle]="'button'"
                    class="w-6"
                    (click)="confirm()">{{'Confirm' | translate}}</button>
        </div>
        <div class="flex flex-middle m-t col-3">
            <i class="icon-geo-direction"></i>
            <button [inlineButton]
                    [status]="locationStatus"
                    (click)="loadCurrentLocation()"
                    class="s2 m-l-1">{{'Use my current location' | translate}}</button>
        </div>
        <div class="m-t">
            <result [status]="locationStatus"></result>
            <result [status]="status"></result>
        </div>
    </div>

    <!-- <div modalFooter>
         <button class="w-12"
                [buttonStyle]
                [disabled]="!postcode"
                [status]="status"
                (click)="confirm()">{{'Confirm' | translate}}</button>
    </div> -->
</modal-layout>
